import { useRef } from 'react';
import { ReactElement, useCallback } from 'react';

import { FormHandles } from '@unform/core';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { GoBackButton, Button } from '~/components';
import { useLoading } from '~/hooks/loading';
import { IMethod } from '~/models/Method';
import { MethodService } from '~/services';
import { handleYupValidationError } from '~/utils';
import { MethodSchema } from '~/utils/schemas/MethodSchema';

import EditMethodForm from '../EditMethodForm';

import * as S from './styles';

function MethodCadaster(): ReactElement {
  const { setLoading } = useLoading();
  const formRef = useRef<FormHandles>(null);
  const router = useHistory();

  const handleCancel = useCallback(() => {
    router.goBack();
  }, [router]);

  const handleMethodCadasterSubmit = useCallback(
    async (data: IMethod) => {
      try {
        setLoading(true);

        formRef.current?.setErrors({});

        const formattedPrinciple = data.method_principle
          ?.replaceAll(',', '&')
          .replaceAll(/&\s/g, '&');

        const formattedData = {
          ...data,
          method_principle: formattedPrinciple,
        };

        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        await MethodSchema(Number(data.series_number || 0)).validate(
          formattedData,
          {
            abortEarly: false,
          },
        );

        const result = await MethodService.createMethod(formattedData);
        if (result.status.toString()[0] === '2') {
          toast.success('Método cadastrado com sucesso!');
          router.goBack();
        } else {
          toast.error('Ocorreu um problema ao cadastrar o método!');
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleYupValidationError(formRef, error);
      }
    },
    [router],
  );

  return (
    <>
      <GoBackButton
        containerStyle={{ alignSelf: 'flex-start', paddingTop: '2.2rem' }}
      />
      <S.Container>
        <S.Header>
          <S.Title>Cadastrar Método</S.Title>
        </S.Header>
        <EditMethodForm
          formName="method-cadaster"
          formRef={formRef}
          handleSubmit={handleMethodCadasterSubmit}
        />
        <S.Footer>
          <Button
            form="method-cadaster"
            type="submit"
            textContent="Salvar"
            variant="black"
            size="small"
            extraStyles={{
              width: '200px',
            }}
          />
          <Button
            type="button"
            onClick={handleCancel}
            textContent="Cancelar"
            variant="red"
            size="small"
            extraStyles={{
              width: '200px',
            }}
          />
        </S.Footer>
      </S.Container>
    </>
  );
}

export default MethodCadaster;
